import type { ScheduleEventQuarter } from '~/types'
import { PeriodType } from '~/enums/period-type'

export const scheduleEventQuarterModelDto = (source: MaybeRef<ScheduleEventQuarter.RawModel>): ScheduleEventQuarter.Model => {
  const {
    vendorData,
    id,
    number,
    sequence,
    scheduleEventId,
  } = unref(source)

  return {
    id,
    number,
    sequence,
    scheduleEventId,
    periodType: vendorData?.periodType ?? PeriodType.Quarter,
    playByPlay: vendorData?.pbp ?? [],
    coinToss: vendorData?.coinToss ?? null,
    scoring: vendorData?.scoring ?? null,
  }
}
